import React, { useEffect } from "react";
import "./Carouse.scss";
import { CarouseProps, ImageCarouseProps } from "./CarouseProps";
const Carouse = (props: CarouseProps) => {
  const { src, style, type, className } = props;
  let slideIndex = 0;
  //   let slideIndex = 1;
  //   showSlides(slideIndex);

  //   // Next/previous controls
  //   function plusSlides(n: any) {
  //     showSlides((slideIndex += n));
  //   }

  //   // Thumbnail image controls
  //   function currentSlide(n: any) {
  //     showSlides((slideIndex = n));
  //   }

  //   function showSlides(n: any) {
  //     let i;
  //     let slides = document.getElementsByClassName("mySlides");
  //     let dots = document.getElementsByClassName("dot");
  //     if (n > slides.length) {
  //       slideIndex = 1;
  //     }
  //     if (n < 1) {
  //       slideIndex = slides.length;
  //     }
  //     for (i = 0; i < slides.length; i++) {
  //       slides[i]?.setAttribute("style", "display :none");
  //     }
  //     for (i = 0; i < dots.length; i++) {
  //       if (dots[i]) {
  //         dots[i].className = dots[i].className.replace(" active", "");
  //       }
  //     }
  //     slides[slideIndex - 1]?.setAttribute("style", "display :block");
  //     if (dots[slideIndex - 1]) {
  //       dots[slideIndex - 1].className += " active";
  //     }
  //   }
  useEffect(() => {
    let slides = document.getElementsByClassName("mySlides");

    if (slides) {
      showSlides();
    }
  }, []);

  //   showSlides();

  function showSlides() {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");
    let nexts = document.getElementsByClassName("next");
    for (i = 0; i < slides.length; i++) {
      slides[i]?.setAttribute("style", "display:none");
    }
    for (i = 0; i < dots.length; i++) {
      if (dots[i]) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      if (i < dots.length - 1) {
        nexts[i].className = nexts[i].className.replace(" next-active", "");
      }
    }

    slideIndex++;
    if (slideIndex > slides.length) {
      slideIndex = 1;
    }
    slides[slideIndex - 1].setAttribute("style", "display:block");
    if (dots[slideIndex - 1]) {
      dots[slideIndex - 1].className += " active";
    }
    if (slideIndex - 1 < dots.length - 1 && nexts[slideIndex - 1]) {
      nexts[slideIndex - 1].className += " next-active";
    }
    setTimeout(showSlides, 5000); // Change image every 2 seconds
  }

  return (
    <div className={`slideshow-container ${className}`}>
      <p className="text-red-300">dsadasdsad</p>
      {src.length > 0 &&
        src.map((image: ImageCarouseProps, index: number) => (
          <div className="mySlides fade">
            {/* <div className="numbertext">{`${index + 1}/${src.length}`}</div> */}
            <img src={image.url} style={{ width: "100%" }} />
            <div className="text">{image.caption}</div>
          </div>
        ))}

      {/* <div className="mySlides fade">
        <div className="numbertext">2 / 3</div>
        <img
          src="https://c.wallhere.com/photos/4b/e1/1500x1000_px_France_landscape_Michel_Mont_Saint_nature_photography_reflection-1266781.jpg!d"
          style={{ width: "100%" }}
        />
        <div className="text">Caption Two</div>
      </div>

      <div className="mySlides fade">
        <div className="numbertext">3 / 3</div>
        <img
          src="https://c.wallhere.com/photos/90/8e/1500x1000_px_China_clouds_field_Guilin_landscape_mist_Morning-1057211.jpg!d"
          style={{ width: "100%" }}
        />
        <div className="text">Caption Three</div>
      </div> */}
      <div
        style={{
          position: "absolute",
          flexDirection: "column",
          top: "50%",
          right: 5,
          // transform: `rotate(90deg)`,
          display: "flex",
        }}
      >
        {src.length > 0 &&
          src.map((image: ImageCarouseProps, index: number) => (
            <>
              <div className="dot" onClick={() => {}}>
                {index < 10 ? "0" + (index + 1) : index + 1}
              </div>
              {index + 1 < src.length ? <div className="next"></div> : <></>}
            </>
          ))}

        {/* <div className="dot" onClick={() => {}}>
          01
        </div>
        <div className="next"></div>
        <div className="dot" onClick={() => {}}>
          02
        </div>
        <span className="next"></span>
        <div className="dot" onClick={() => {}}>
          03
        </div> */}
      </div>
      {/* <a className="prev" onClick="plusSlides(-1)">&#10094;</a>
    <a className="next" onclick="plusSlides(1)">&#10095;</a> */}
    </div>
  );
};

export default Carouse;
